export default __webpack_public_path__ + "static/media/cap_reduced.bb8a4f5e.jpg";